require('../modules/web.dom.iterable');
module.exports = require('../modules/_core');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/web/dom-collections.js
// module id = 290
// module chunks = 0